import S from 'pull-stream';
import Pushable from 'pull-pushable';
import config from '../config';
function isDev () {
    return process.env.NODE_ENV === 'development';
}

function Log (namespace) {
    var pushable = Pushable();

    if (!isDev) {
        S(pushable, S.drain());
        return pushable;
    }

    try {
        var ws = new WebSocket(config.logUrl);

        ws.addEventListener('error', function (err) {
            console.warn('no websocket log :(');
            S(
                pushable,
                S.drain()
            );
        });

        ws.addEventListener('open', function () {
            S(
                pushable,
                S.drain(function onEvent (ev) {
                    ws.send(JSON.stringify(ev));
                }, function onEnd (err) {
                    if (err) console.log('log error', err);
                })
            );
        });

    } catch (err) {
        // drain the stream so that it does not buffer forever
        S(
            pushable,
            S.drain()
        );
    }

    return pushable;
}

export default Log;
